module.exports = __webpack_public_path__ + "img/power-charge.916bb71c.svg";